import React, { useState, useContext} from 'react'

import { GlobalContext } from '../context/GlobalState';

export const AddTransaction = () => {

    const [text, setText] = useState("")
    const [amount, setAmount] = useState(0);

    const {addTransaction} = useContext(GlobalContext);

    const onSubmit = (e) =>{

        e.preventDefault();

        const newTransaction = {

            id: Math.floor(Math.random() * 100000000),
            text: text,
            amount: +amount //to convert it number from string
        }

        addTransaction(newTransaction);

    }

    return (
        <div>
            
            <h3>Add new transaction</h3>
      <form onSubmit={onSubmit}>
        <div className="form-control">

          <label htmlFor="text">Text</label>

          <input type="text" value={text} onChange={(e) => setText(e.target.value
           ) } placeholder="Enter text..." / >


        </div>
        <div className="form-control">
          <label htmlFor="amount"
           > <h3 >Amount: </h3> <br />
            <div style={{color: "#83e85a"}}>(use positive sign (+) for income & negative sign (-) for expense) </div></label
          >
          <input type="number"  onChange={(e) =>setAmount(e.target.value)} placeholder="Enter amount with (+/-)..." />
        </div>
        <button className="btn"> <b style={{color: "black"}}>Add transaction </b></button>
      </form>


        </div>
    )
}
